import { useTranslation } from 'react-i18next'
import { Plus, X } from 'lucide-react'

interface BulletListEditorProps {
  bullets: string[]
  onChange: (bullets: string[]) => void
  maxBullets?: number
  inputClassName: string
}

export function BulletListEditor({ bullets, onChange, maxBullets = 5, inputClassName }: BulletListEditorProps) {
  const { t } = useTranslation()

  const addBullet = () => { if (bullets.length < maxBullets) onChange([...bullets, '']) }
  const removeBullet = (i: number) => onChange(bullets.filter((_, idx) => idx !== i))
  const updateBullet = (i: number, v: string) => onChange(bullets.map((b, idx) => idx === i ? v : b))

  return (
    <div>
      <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1">
        {t('amazonListing.manual.bullets')}
      </label>
      {bullets.map((b, i) => (
        <div key={i} className="flex gap-1 mb-1">
          <textarea rows={1} value={b} onChange={(e) => updateBullet(i, e.target.value)} className={`${inputClassName} flex-1`} />
          {bullets.length > 1 && (
            <button type="button" onClick={() => removeBullet(i)} className="p-1 text-neutral-400 hover:text-red-500">
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      ))}
      {bullets.length < maxBullets && (
        <button type="button" onClick={addBullet} className="text-xs text-orange-500 hover:text-orange-600 flex items-center gap-1 mt-1">
          <Plus className="h-3 w-3" /> {t('amazonListing.manual.addBullet')}
        </button>
      )}
    </div>
  )
}
